<table-dynamic [config]="{
                title: 'Movimientos de Stock',
                columns: cols(),
                data: data() || [],
                totalRecords: totalRecords(),
                first: first(),
                showFilters: true,
                loading: loading(),
                localFilter: false,
                showPagination: true,
                pageSize: pageSize(),
                lazy: true,
                sortField: sortField(),
                sortOrder: sortOrder()
            }"
    [actionButtons]="actionButtons()"
    (onLazyLoad)="loadData($event)"
    (onPageChange)="loadData($event)"
    (onSearch)="loadData({ globalFilter: $event })"
    (onNew)="newItem()"
    (onEdit)="editItem($event)"
    (onDelete)="deleteItem($event)">
</table-dynamic>
